import React, { Component } from 'react';
import { Button, Container, Col, Card, Row, InputGroup, Image, Form } from 'react-bootstrap';
import Footers from "../Footers/Footer";
import Headers from '../Headers/Headers';
import {BasicTable} from './BasicTable.js'
function guidelines()
{
    return(
       <div>
           <BasicTable/>
        </div>
    )
}
export default guidelines;